import { useState, useEffect } from "react";
import { Box, Button, CardContent, Divider, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { findSettings, setSettings } from "../../../utils/settings/fetchSettings";
import { auth } from "../../../../contexts/authentication";
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import SuccessAlert from "../../../components/SucessAlert";

export default function Settings() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down(570));
  const [rejectCall, setRejectCall] = useState(false);
  const [msgCall, setMsgCall] = useState('');
  const [groupsIgnore, setGroupsIgnore] = useState(false);
  const [alwaysOnline, setAlwaysOnline] = useState(false);
  const [readMessages, setReadMessages] = useState(false);
  const [readStatus, setReadStatus] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const currentUser = auth.currentUser;
  const uid = currentUser?.uid;

  useEffect(() => {
    if (showSuccessAlert) {
      setTimeout(() => {
        setShowSuccessAlert(false)
      }, 6000)
    }
  }, [showSuccessAlert])

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await findSettings(uid);
        setRejectCall(data.rejectCall);
        setMsgCall(data.msgCall);
        setGroupsIgnore(data.groupsIgnore);
        setAlwaysOnline(data.alwaysOnline);
        setReadMessages(data.readMessages);
        setReadStatus(data.readStatus);
      } catch (error) {
        console.error('Erro ao buscar configurações:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <CardContent sx={{ flexGrow: 1, p: '24px !important' }}>
      <Box sx={{ mb: 5 }}>
        <Typography gutterBottom variant={isDesktop ? "h4" : "h6"} component="div">
          Preferências
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Configure o comportamento desejado para o número conectado.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <FormGroup sx={{
          ml: isDesktop ? 2 : 0,
          mr: isDesktop ? 2 : 0
        }}>
          <Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                <label htmlFor="alwaysOnline">
                  <Typography variant="body2">
                    Sempre Online
                  </Typography>
                </label>
                <Tooltip
                  title="Mantém seu status online, mesmo se fechar o app"
                  arrow
                  placement="top"
                  enterTouchDelay={0}
                  leaveTouchDelay={7000}
                >
                  <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
                </Tooltip>
              </Box>
              <Switch
                id="alwaysOnline"
                checked={alwaysOnline}
                onChange={() => setAlwaysOnline(!alwaysOnline)}
              />
            </Box>
          </Box>
          <Divider />
          <Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                <label htmlFor="readMessages">
                  <Typography variant="body2">
                    Mensagem sempre lida
                  </Typography>
                </label>
                <Tooltip
                  title="Confirma a visualização da mensagem"
                  arrow
                  placement="top"
                  enterTouchDelay={0}
                  leaveTouchDelay={7000}
                >
                  <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
                </Tooltip>
              </Box>
              <Switch
                id="readMessages"
                checked={readMessages}
                onChange={() => setReadMessages(!readMessages)}
              />
            </Box>
          </Box>
          <Divider />
          <Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                <label htmlFor="readStatus">
                  <Typography variant="body2">
                    Visualizar Status
                  </Typography>
                </label>
                <Tooltip
                  title="Todos os status serão visualizados por você"
                  arrow
                  placement="top"
                  enterTouchDelay={0}
                  leaveTouchDelay={7000}
                >
                  <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
                </Tooltip>
              </Box>
              <Switch
                id="readStatus"
                checked={readStatus}
                onChange={() => setReadStatus(!readStatus)}
              />
            </Box>
          </Box>
          <Divider />
          <Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                <label htmlFor="groupsIgnore">
                  <Typography variant="body2">
                    Ignorar Grupos
                  </Typography>
                </label>
                <Tooltip
                  title="Ignorar todas as mensagens de grupos"
                  arrow
                  placement="top"
                  enterTouchDelay={0}
                  leaveTouchDelay={7000}
                >
                  <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
                </Tooltip>
              </Box>
              <Switch
                id="groupsIgnore"
                checked={groupsIgnore}
                onChange={() => setGroupsIgnore(!groupsIgnore)}
              />
            </Box>
          </Box>
          <Divider />
          <Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.7 }}>
                <label htmlFor="rejectCall">
                  <Typography variant="body2">
                    Rejeitar ligações
                  </Typography>
                </label>
                <Tooltip
                  title="Rejeitar todas as chamadas"
                  arrow
                  placement="top"
                  enterTouchDelay={0}
                  leaveTouchDelay={7000}
                >
                  <InfoOutlinedIcon sx={{ fontSize: '1rem' }} />
                </Tooltip>
              </Box>
              <Switch
                id="rejectCall"
                checked={rejectCall}
                onChange={() => setRejectCall(!rejectCall)}
              />
            </Box>
            {rejectCall && (
              <TextField
                id="standard-basic"
                label="Mensagem de rejeição"
                placeholder={isMobile ? '' : 'Digite uma mensagem a ser enviada quando rejeitar uma ligação.'}
                variant="standard"
                value={msgCall}
                onChange={(e) => setMsgCall(e.target.value)}
                sx={{
                  width: '100%',
                }}
              />
            )}
          </Box>
        </FormGroup>
        <Button
          variant="contained"
          onClick={() => {
            setSettings(
              uid, rejectCall, msgCall, groupsIgnore, alwaysOnline, readMessages, readStatus
            );
            setShowSuccessAlert(true);
          }}
          sx={{
            width: 'max-content',
            alignSelf: 'center',
          }}
        >
          Salvar
        </Button>
        {showSuccessAlert && (
          <SuccessAlert message="Configurações salvas com sucesso"/>
        )}
      </Box>
    </CardContent>
  );
}